import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import PresenceAvatar from "@/components/PresenceAvatar";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ActiveContactsStrip() {
  const [contacts, setContacts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    let alive = true;
    const load = () => axios.get(`${API}/presence/active-contacts`).then(r => alive && setContacts(r.data || [])).catch(() => {});
    load();
    const iv = setInterval(load, 20000);
    return () => { alive = false; clearInterval(iv); };
  }, []);

  if (contacts.length === 0) return null;

  return (
    <div className="px-3 pb-2 border-b border-border/60 mb-1" data-testid="active-contacts-strip">
      <div className="text-[11px] font-semibold text-muted-foreground uppercase tracking-wide mb-2">Contatos ativos</div>
      <div className="flex gap-3 overflow-x-auto pb-1 -mx-1 px-1">
        {contacts.map(c => (
          <button
            key={c.user_id}
            data-testid={`active-contact-${c.user_id}`}
            onClick={() => navigate(`/chat/${c.user_id}`)}
            className="flex flex-col items-center gap-1 w-14 shrink-0 hover:opacity-80 transition-opacity"
          >
            <PresenceAvatar src={c.picture} name={c.name} online className="w-12 h-12" dotClass="w-3.5 h-3.5" />
            <span className="text-[11px] truncate w-full text-center">{(c.name || "").split(" ")[0]}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
